import { SelectorEnum } from '@/src/ContactsModule/components/ContactsMappingField/selectorsValues';

export const isValidFormat = (
  item: string,
  validator: string,
  dataType: string | undefined
): boolean => {
  if (dataType === SelectorEnum.sex) {
    const validValues = validator.split(' - ');
    const firstValue = validValues[0].toLowerCase();
    const secondValue = validValues[1].toLowerCase();
    item = item.toLowerCase();
    if (item !== firstValue && item !== secondValue) {
      return false;
    }
  } else if (dataType === SelectorEnum.date) {
    return isValidDate(item, validator);
  } else if (dataType === SelectorEnum.country) {
    return isValidCountry(item, validator);
  }

  return true;
};

export const isValidDate = (rowValue: string, validator: string) => {
  let pattern;
  let isValid = false;
  let split;

  switch (validator) {
    case 'dd/mm/yyyy':
      split = rowValue.split('/').map((item) => parseInt(item));
      isValid = validateDate(split[0], split[1], split[2]);
      break;
    case 'yyyy/mm/dd':
      split = rowValue.split('/').map((item) => parseInt(item));
      isValid = validateDate(split[2], split[1], split[0]);
      break;
    case 'dd-mm-yyyy':
      split = rowValue.split('-').map((item) => parseInt(item));
      isValid = validateDate(split[0], split[1], split[2]);
      break;
    case 'yyyy-mm-dd':
      split = rowValue.split('-').map((item) => parseInt(item));
      isValid = validateDate(split[2], split[1], split[0]);
      break;
    default:
      pattern = new RegExp(/^\d{1,2}-\d{1,2}-\d{2,4}$/);
      break;
  }

  return isValid;
};

const validateDate = (day: number, month: number, year: number): boolean => {
  const adjustedMonth = month - 1;
  const date = new Date(year, adjustedMonth, day);

  const realDate = {
    day: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear(),
  };
  const isValid =
    realDate.year === year && realDate.month === adjustedMonth && realDate.day === day;

  if (adjustedMonth === 1 && day === 29)
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

  return isValid;
};

export const isValidCountry = (rowValue: string, validator: string) => {
  let pattern;

  switch (validator) {
    case '2d-a':
      pattern = new RegExp(/^[a-z\d]{1,2}$/i);
      break;
    case '3d-a':
      pattern = new RegExp(/^[a-z\d]{1,3}$/i);
      break;
    case '3d-n':
      pattern = new RegExp(/^\d{1,3}$/);
      break;
    default:
      pattern = new RegExp(/^[a-z\d]{1,2}$/i);
      break;
  }

  return pattern.test(rowValue);
};
